module.exports = __webpack_public_path__ + "static/media/8604-r-en.91b565fa.png";